import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { Step4 } from "./Step4";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Paper } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const RegisterForm = () => {
  const navigate = useNavigate();
  const steps = ["Basic Details", "Address", "Images", "Login Details"];
  const [activeStep, setActiveStep] = React.useState(0);
  const defaultValues = {
    // orgName: "",
    // lastname: "",
    // address: "",
    // city: "",
  };
  const validationSchema = [
    // validation for step1
    // yup.object({
    //   orgName: yup.string().required("Required"),
    //   desc: yup.string().required("Required"),
    //   type: yup.string().required("Required"),
    // }),
    yup.object(),
    yup.object(),
    yup.object(),
    yup.object(),
  ];
  const currentValidationSchema = validationSchema[activeStep];
  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(currentValidationSchema),
    mode: "onChange",
  });
  const { handleSubmit, trigger } = methods;
  // const onSubmit = (data) => {
  //   alert(JSON.stringify(data));
  //   handleNext();
  // };

  const onSubmit = (data) => {
    console.log(data);
    console.log("+++++++++++++++++");
    let formData = new FormData();
    for (let key in data) {
        if(key === "images_files")
        {
          data[key].map((item)=>{
            formData.append(key, item)
          })
        }
        else{
          formData.append(key, data[key]);
        }
    }
    for(data of formData.entries())
    {
      console.log(data);
    }

    axios
      .post("http://localhost:3000/api/v1/orgUsers/signup", formData, {
        headers: {"Content-Type": "multipart/form-data"}
      })
      .then(function (response) {
        console.log(response);
        navigate("/login");
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const handleNext = async () => {
    const isStepValid = await trigger();
    if (isStepValid) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const getStepContent = () => {
    switch (activeStep) {
      case 0:
        return <Step1 />;
      case 1:
        return <Step2 />;
      case 2:
        return <Step3 />;
      case 3:
        return <Step4 />;
      default:
        return null;
    }
  };
  return (
    <Paper elevation={3} sx={{ width: "70%", mx: "auto", mt: 4, p: 3 }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          return (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <div style={{ minHeight: "50%" }}>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <FormProvider {...methods}>
              <form>
                <Box my={2} sx={{ minHeight: "25vh" }}>
                  {getStepContent()}
                </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  style={{ paddingTop: "5vh" }}
                >
                  <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Back
                  </Button>
                  {activeStep === steps.length - 1 ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Sign Up
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                    >
                      Next
                    </Button>
                  )}
                </Box>
              </form>
            </FormProvider>
          </React.Fragment>
        )}
      </div>
    </Paper>
  );
};

export default RegisterForm;
